// extracted by mini-css-extract-plugin
export default {"root":"ConfirmDialog-rebranding-module__root___2FmSl","wrapper":"ConfirmDialog-rebranding-module__wrapper___3wRdN","header":"ConfirmDialog-rebranding-module__header___1BVax"};